var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.cell
    ? _c("div", [
        _c("table", { staticClass: "col" }, [
          _c("tr", [
            _c("td", [
              _c("div", [_c("span", [_vm._v(_vm._s(_vm.$t("txtIdent2")))])]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.cell.ident2,
                    expression: "cell.ident2"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.cell.ident2 },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.cell, "ident2", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("td", [
              _c("div", { staticClass: "d-inline-block w-50" }, [
                _vm._v(_vm._s(_vm.$t("cellBaseLineHours")))
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.baseLineHours,
                    expression: "baseLineHours"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "number", lang: _vm.$i18n.locale },
                domProps: { value: _vm.baseLineHours },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.baseLineHours = $event.target.value
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c(
              "td",
              [
                _c("span", { staticClass: "align-middle d-inline-block" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("cellColor") + ":") +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _vm.cell.color
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.cell.color,
                          expression: "cell.color"
                        }
                      ],
                      staticClass:
                        "align-middle border-0 d-inline-block m-0 p-0",
                      staticStyle: { background: "unset" },
                      attrs: { type: "color" },
                      domProps: { value: _vm.cell.color },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.cell, "color", $event.target.value)
                        }
                      }
                    })
                  : _c("span", { staticClass: "align-middle d-inline-block" }, [
                      _vm._v(_vm._s("(" + _vm.$t("cellNoColor") + ")"))
                    ]),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "align-middle border box d-inline-block mx-1 unsetbox",
                  attrs: { title: _vm.$t("cellNoColor") },
                  on: {
                    click: function($event) {
                      _vm.cell.color = null
                    }
                  }
                }),
                _vm._v(" "),
                _vm._l(_vm.predefinedColors, function(color) {
                  return _c("div", {
                    staticClass: "align-middle border box d-inline-block mx-1",
                    style: { "background-color": color.color },
                    attrs: { title: color.name },
                    on: {
                      click: function($event) {
                        _vm.cell.color = color.color
                      }
                    }
                  })
                })
              ],
              2
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }